import {findKey} from '@/utils.js'

function Theme () {
  return {
    name: "",
    route: "",
    questions: [],
    getRandomQuestion: function () {
      return this.questions.length > 0 ? this.questions[Math.floor(Math.random() * this.questions.length)] : null
    }
  }
}

function Chamber () {
  return {
    name: ""
  }
}

function Source () {
  return {
    url: "",
    name: "",
    img: "",
    imgtag: "",
    active: true
  }
}

function Article () {
  return {
    name: "",
    img: "",
    description: "",
    setImage: function () {
      this.img = this.imgtag ? findKey(this.rss[this.imgtag],"url") : null;
    }
  }



}

export {
  Theme,
  Chamber,
  Source,
  Article
}
